module.exports = __webpack_public_path__ + "img/0230_japanese-paper_00128.0316fbf9.jpg";